import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {EmptyState, Loader} from "components";
import {HistoryCard} from "./historyCard";
import {historyActions} from "store";
import {FindLoad} from "utils";
import {GET_HISTORY} from "store/history";
import {Svg} from "../../assets";

export const History = ({
                            currentId,
                            notTitleText = 'No History Yet',
                            notDescText = 'There are no recent activities or logs to display here.',
                        }) => {
    const dispatch = useDispatch();
    const historyList = useSelector((state) => state.history.historyList);
    const loading = FindLoad(GET_HISTORY);

    useEffect(() => {
        if (currentId) {
            dispatch(historyActions.getHistory({onResource: currentId}));
        }
    }, [currentId, dispatch]);

    if (loading) {
        return (
            <div className="history-cards-wrapper">
                <Loader styles={{width: '80px', height: '80px', margin: 'auto'}}/>
            </div>
        );
    }

    if (!historyList?.length) {
        return (
            <EmptyState
                notTitleText={notTitleText}
                notDescText={notDescText}
                EmptySvg={Svg.HistoryEmptySvg}
                styles={{height: '50vh'}}
            />
        );
    }

    return (
        <div className="history-cards-wrapper">
            {historyList?.map((item, index) => (
                <HistoryCard data={item} key={index}/>
            ))}
        </div>
    );
};
